// libraries
import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { Avatar, Tooltip, Typography } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import * as Colors from '@ant-design/colors';

import { txt } from '../../../../locales/i18n';
import { formatDate } from '../../../../utils/date';
import { useDeviceSize } from '../../../../hooks/device-size';
import * as userService from '../../../../services/bb-api/user';
import { renderHeaderSubscription } from '../../../shared/subscriptions';

export function PostPageHeader({ post }: any): JSX.Element {
	const [profileImage, setProfileImage] = useState<string | null>(null);
	const isMobileDevice = useDeviceSize();

	useEffect(() => {
		if (isMobileDevice) return;
		userService.getProfileImage(post.userId).then(setProfileImage);
	}, [post.userId, isMobileDevice]);

	const renderPreviousApprovedDate = () => {
		if (!post.previousApprovedDate) return null;
		const date = post.previousApprovedDate ?? post.previousPost.changed_date + 'z';

		return (
			<Tooltip title={txt('global.last approved')}>
				<Typography.Text italic style={{ color: Colors.green.primary }}>
					{formatDate(date)}
				</Typography.Text>
			</Tooltip>
		);
	};

	return (
		<StyledSection>
			{isMobileDevice === false && (
				<Avatar size={64} src={profileImage} icon={<UserOutlined />} />
			)}

			<div className="details-container">
				<h3>
					<Tooltip title={txt('global.open')}>
						<Typography.Link ellipsis href={`/users/${post.user_id}`}>
							{post.username}
						</Typography.Link>
					</Tooltip>

					<Typography.Text>{post.userMunicipalityName}</Typography.Text>

					<Typography.Text type="secondary" ellipsis>
						{post.userEmail}
					</Typography.Text>
				</h3>

				<Typography.Text ellipsis className="date-container">
					<Tooltip title={txt('global.created')}>
						<Typography.Text>{formatDate(post.created)}</Typography.Text>
					</Tooltip>

					{post.edit_date !== post.created && (
						<Tooltip title={txt('global.last edited')}>
							<Typography.Text type="secondary">
								({formatDate(post.edit_date)})
							</Typography.Text>
						</Tooltip>
					)}

					{renderPreviousApprovedDate()}
				</Typography.Text>
			</div>

			{post.userSubscription && renderHeaderSubscription(post.userSubscription, isMobileDevice)}
		</StyledSection>
	);
}

const StyledSection = styled.section`
	display: flex;
	align-items: center;
	gap: 1em;
	padding: 1ch 2ch;

	.details-container {
		display: flex;
		flex-direction: column;
		max-width: 70%;

		h3 {
			margin: 0;
			display: flex;
			flex-wrap: wrap;
			gap: 1ch;
		}

		.date-container {
			display: flex;
			gap: 1ch;
		}
	}
`;
